import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Logo } from "./Logo";
import { ThemeToggle } from "./ThemeToggle";
import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/providers";

export function MobileNav() {
    const { isAuthenticated } = useAuth();
    return (
        <Sheet>
            <SheetTrigger asChild>
                <Button variant="outline" size="icon" className="md:hidden"><Menu className="size-4" /></Button>
            </SheetTrigger>
            <SheetContent side="left" className="flex flex-col gap-6">
                <SheetHeader className="text-left">
                    <SheetTitle className="flex items-center"><Logo compact /></SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col gap-3 text-sm">
                    <Link to="/" className="hover:text-primary cursor-pointer">Home</Link>
                    <Link to="/#features" className="hover:text-primary cursor-pointer">Features</Link>
                    <Link to="/#faq" className="hover:text-primary cursor-pointer">FAQ</Link>
                    {!isAuthenticated && <Link to="/login" className="hover:text-primary cursor-pointer">Login</Link>}
                    {!isAuthenticated && <Link to="/register" className="hover:text-primary cursor-pointer">Register</Link>}
                </nav>
                <div className="mt-auto pt-4 flex items-center gap-3">
                    <ThemeToggle />
                </div>
            </SheetContent>
        </Sheet>
    );
}
